import { filter, first, map, Observable } from 'rxjs';

import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { UserSubscription } from '@metodics/api-client';

import { Facade } from '../+state/facade';

@Injectable()
export class LoadAllUsersSubscriptionsGuard implements CanActivate {
  constructor(private facade: Facade) {}

  canActivate(): Observable<boolean> {
    return this.facade.getUsersSubscriptions$.pipe(
      map((userSubscriptions: UserSubscription[] | undefined) => {
        const loaded = userSubscriptions !== undefined;
        if (!loaded) {
          this.facade.loadUsersSubscriptions();
        }
        return loaded;
      }),
      filter((loaded) => loaded),
      first()
    );
  }
}
